export function isFullChainPdfVariant(variant) {
  return String(variant || '').startsWith('full-chain');
}

export function buildExamOnlyVariant(variant) {
  const normalized = String(variant || '');
  if (normalized === 'full-chain-single') {
    return 'exam-report-single';
  }
  if (normalized === 'full-chain-selection') {
    return 'exam-report-selection';
  }
  if (normalized === 'full-chain-all') {
    return 'exam-report-all';
  }
  return normalized || 'exam-report-all';
}

export function buildFullChainSourcePlan(model = {}) {
  const exportType = String(model?.exportType || '');
  const participantScoped = exportType.endsWith('-selection') || exportType.endsWith('-single');
  const participants = Array.isArray(model?.participants) ? model.participants : [];

  const assessmentExportsByEventId = new Map();
  const courseExportsByCourseId = new Map();

  participants.forEach((participant) => {
    const events = Array.isArray(participant?.assessmentEvents) ? participant.assessmentEvents : [];
    events.forEach((event) => {
      const eventId = Number(event?.eventId || 0);
      if (!Number.isInteger(eventId) || eventId <= 0) {
        return;
      }

      if (!assessmentExportsByEventId.has(eventId)) {
        assessmentExportsByEventId.set(eventId, {
          eventId,
          eventCandidateIds: [],
        });
      }

      if (participantScoped) {
        const eventCandidateId = Number(event?.eventCandidateId || 0);
        if (Number.isInteger(eventCandidateId) && eventCandidateId > 0) {
          assessmentExportsByEventId.get(eventId).eventCandidateIds.push(eventCandidateId);
        }
      }
    });

    const courseId = Number(participant?.course?.courseId || participant?.courseId || 0);
    if (!Number.isInteger(courseId) || courseId <= 0) {
      return;
    }

    if (!courseExportsByCourseId.has(courseId)) {
      courseExportsByCourseId.set(courseId, {
        courseId,
        participantIds: [],
      });
    }

    if (participantScoped) {
      const courseParticipantId = Number(participant?.course?.courseParticipantId || participant?.courseParticipantId || 0);
      if (Number.isInteger(courseParticipantId) && courseParticipantId > 0) {
        courseExportsByCourseId.get(courseId).participantIds.push(courseParticipantId);
      }
    }
  });

  const assessmentExports = [...assessmentExportsByEventId.values()].map((entry) => ({
    eventId: entry.eventId,
    eventCandidateIds: [...new Set(entry.eventCandidateIds)].sort((left, right) => left - right),
  }));

  const courseExports = [...courseExportsByCourseId.values()].map((entry) => ({
    courseId: entry.courseId,
    participantIds: [...new Set(entry.participantIds)].sort((left, right) => left - right),
  }));

  return {
    assessmentExports,
    courseExports,
  };
}
